<template>
    <div>
        <overview
            v-if="!globalLoading"
            :name="name"
            :dataoverview="dataoverview"
            :mappingName="mappingName"
            :overviewClass="overviewClass"
            :nav="navMap"
            :moreNav="moreNav"
            :contextId="contextId"
        >
        </overview>
    </div>
</template>

<script>
import Overview from 'vcomponents/overview/Overview.vue';
import OverviewPeopleModule from '../../store/overview/overviewPeople';
import OverviewMixin from '../overview/OverviewMixin';

import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('system');

export default {
    components: {
        Overview,
    },
    mixins: [OverviewMixin],
    data() {
        return {
            module: OverviewPeopleModule,
        };
    },
    computed: {
        ...mapState({
            globalLoading: 'globalLoading',
        }),
    },
    created() {
        this.init(this.$route.params.id);
    },
    beforeUnmount() {
        this.$storeHasModule('people') ? this.$store.unregisterModule('people') : null;
    },
    methods: {
        ...mapActions(['toggleLoading']),
        init(id) {
            this.moreNav = [];
            this.navMap = [];

            this.toggleLoading();
            this.overviewClass
                .fetch(id)
                .then((response) => {
                    this.initStore(response).then(() => {
                        this.moreNav = this.overviewClass.getMoreNav();
                        this.navMap = this.buildNav(this.overviewClass.getNav());
                        this.setDataoverview();
                        this.dispatchData();
                        this.toggleLoading();
                        this.$store.dispatch('updateCsrfToken', response.crsf_token);
                    });
                })
                .catch(() => {
                    Push.error(this.$l10n.__("Vous n'avez pas les droits nécessaires"));
                    this.toggleLoading();
                    this.$router.push({ name: 'people' });
                });
        },
    },
};
</script>
